// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import i18n from '../../i18n/i18n'
import 'jquery'

import ElementUI from 'element-ui' // 引入EelmentUI组件
import 'element-ui/lib/theme-chalk/index.css'
import '../../assets/iconfont/iconfont.css'
import 'font-awesome/css/font-awesome.css'
import axios from 'axios';
import echarts from 'echarts'
import App from './App'
import router from './router'

import download from "../../../static/js/download.js";
import Vant from 'vant';
import { Notify } from 'vant';
import { Dialog } from 'vant';
import { Lazyload } from 'vant';
import { areaList } from '@vant/area-data';
import 'vant/lib/index.css';
import { Area } from 'vant';
// import VideoPlayer from 'vue-video-player'

import FileSaver from 'file-saver'

import * as XLSX from 'xlsx'
import moment from 'moment'
import qs from 'qs';
// import 'video.js/dist/video-js.css' // css 一定要引入

// Vue.use(VideoPlayer) // 挂载到vue上

Vue.directive('loadmore', {
    bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
        selectWrap.addEventListener('scroll', function () {
            let sign = 10
            const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            if (scrollDistance <= sign) {
                binding.value()
            }
        })
    }
})

Vue.use(Vant);


Vue.use(Notify);
Vue.use(Dialog);
Vue.use(areaList);
Vue.use(Lazyload);
Vue.use(Area);

Vue.prototype.$download = download;
Vue.prototype.$echarts = echarts;
//axios.defaults.baseURL = config.SERVICE_CONTEXT_PATH; // 配置axios全局请求地址
axios.defaults.timeout = 180000;
axios.interceptors.request.use((config) => {
    // console.log(config);
    
    let storage = window.sessionStorage;
    let token = storage.getItem("token");
    //判断params或data中是否有token
    if (config.params && config.params.token) {
        delete config.params.token;
    }
    if (config.data && config.data.token) {
        delete config.data.token;
    }
    if (config.headers.authorization) {
        delete config.headers.authorization;
    }
    if (token !== null) {
        //高德API请求不需要token
        if (config.url !== "https://restapi.amap.com/v3/config/district?parameters") {
            //为请求头对象，添加token 验证的 Authorization 字段
            config.headers.Authorization = token;
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }

    }

    return config;
}, function (error) {
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        console.log("请求超时");
    } else {
        console.log("其他错误", error);
    }
    return Promise.reject(error);
});
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.$FileSaver = FileSaver;
Vue.prototype.$XLSX = XLSX;


Vue.use(ElementUI)
Vue.filter('dateFormat', function (daraStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(daraStr).format(pattern)
})

//获取角色信息，根据用户权限动态加载路由
router.beforeEach((to, from, next) => {

    let storage = window.sessionStorage;
    let token = storage.getItem("token"); // 保存用户登录信息
    let url = to.path;
    let path = url.substring(0, 4)
    console.log(url)
    if (path === '/wx_') {

        if (!store.getters.info.role) {
            !async function getAddRouters() {
                // 省略 axios 请求代码 通过 token 向后台请求用户权限等信息，这里用假数据赋值
                await store.dispatch('getInfo', {
                    role: 'admin',
                    permissions: '管理员'
                })
                await store.dispatch('newRoutes', store.getters.info.role)
                await router.addRoutes(store.getters.addRouters)
                next({ path: '/wx_ticketIndex' })
            }()
        } else {
            let is404 = to.matched.some(record => {
                if (record.meta.role) {
                    return record.meta.role.indexOf(store.getters.info.role) === -1
                }
            })
            if (is404) {
                next({ path: '/404' })
                return false
            }
            next()
        }
    } else if (path === '/lis') {

        if (!store.getters.info.role) {
            !async function getAddRouters() {
                // 省略 axios 请求代码 通过 token 向后台请求用户权限等信息，这里用假数据赋值
                await store.dispatch('getInfo', {
                    role: 'admin',
                    permissions: '管理员'
                })
                await store.dispatch('newRoutes', store.getters.info.role)
                await router.addRoutes(store.getters.addRouters)
                next({ path: '/listStatements' })
            }()
        } else {
            let is404 = to.matched.some(record => {
                if (record.meta.role) {
                    return record.meta.role.indexOf(store.getters.info.role) === -1
                }
            })
            if (is404) {
                next({ path: '/404' })
                return false
            }
            next()
        }
    } else if (token) {
        if (to.path === '/login') {
            next({ path: '/' })
        } else {
            if (!store.getters.info.role) {
                !async function getAddRouters() {
                    // 省略 axios 请求代码 通过 token 向后台请求用户权限等信息，这里用假数据赋值

                    await store.dispatch('getInfo', {
                        role: 'admin',
                        permissions: '管理员'
                    })
                    await store.dispatch('newRoutes', store.getters.info.role)
                    await router.addRoutes(store.getters.addRouters)
                    next({ path: '/index' })
                }()
            } else {
                let is404 = to.matched.some(record => {
                    if (record.meta.role) {
                        return record.meta.role.indexOf(store.getters.info.role) === -1
                    }
                })
                if (is404) {
                    next({ path: '/404' })
                    return false
                }
                next()
            }
        }
    } else {
        if (to.path === '/login') {
            next()
        }
        next({ path: '/login' })
    }
})


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/system/index/index.js